import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { ConsoleLogger } from 'src/lib/console-logger'

@Component({
  selector: 'maglive-update-nickname',
  templateUrl: './update-nickname.component.html',
  styleUrls: ['./update-nickname.component.scss'],
})
export class UpdateNicknameComponent implements OnDestroy {
  @Input() isScreenRotated: boolean
  @Output() closeUpdateNicknameModalEvent = new EventEmitter<void | boolean>()

  /* Subscription */
  private putMyProfileSub: Subscription | undefined

  isInputFocussed = false
  inputedNickname: string | null = null
  errorMessage: string | null = null
  updateProcessing = false

  constructor(private logger: ConsoleLogger) {}

  ngOnDestroy(): void {
    if (this.putMyProfileSub) {
      this.putMyProfileSub.unsubscribe()
    }
  }

  focusOnInputNickname() {
    this.isInputFocussed = true
  }

  focusOutInputNickname() {
    if (this.inputedNickname) {
      return
    } else {
      this.isInputFocussed = false
      return
    }
  }

  /**
   * スキップボタン押下時の処理
   */
  closeModalForSkip() {
    this.inputedNickname = null
    this.errorMessage = null
    this.closeUpdateNicknameModalEvent.emit(true)
  }

  /**
   * ニックネームのバリデーション
   * 入力イベントに発火するメソッド
   */
  nicknameInput() {
    if (String(this.inputedNickname).length > 15) {
      this.errorMessage = 'ニックネームは15文字以下で入力してください。'
    } else {
      this.errorMessage = null
    }
  }

  /**
   * ニックネームのアップデート処理
   */
  updateNickname() {
    if (!this.inputedNickname || this.errorMessage) return
    if (this.updateProcessing) return

    this.logger.info(
      this.constructor.name,
      'updateNickname',
      'inputedNickname',
      this.inputedNickname
    )
    this.updateProcessing = true

    this.putMyProfileSub = MagliveApiClient.putMyProfile(
      String(this.inputedNickname)
    ).subscribe(
      (x) => {
        if (x !== 'SERVER_ERROR') {
          this.inputedNickname = null
          this.errorMessage = null
          this.closeUpdateNicknameModalEvent.emit()
        } else {
          this.errorMessage =
            '正常に登録できませんでした。もう一度登録を行ってください。'
        }
        this.updateProcessing = false
      },
      (error) => {
        console.error(error)
        this.updateProcessing = false
        this.errorMessage =
          '正常に登録できませんでした。もう一度登録を行ってください。'
      }
    )
  }
}
